import React, { useState, useEffect } from "react";
import styles from "../assets/css/UserList.module.css";
import commonCss from "../assets/css/common.module.css";
import { Loader } from "../../components/Loader";
import { postData1, updateSpecialityList, deleteSpeciality } from "../../services";
import { BackgroundBlur } from "../../utils/Popups";
import { ToastContainer, toast } from "react-toastify";
import { Pagination } from "../Common";
import { FiEdit } from 'react-icons/fi'; // Pencil/Edit icon
import { RiDeleteBin6Line } from 'react-icons/ri';
export const Speciality = () => {
  const [showForm, setForm] = useState(false);
  const [SpeclistData, setSpecListData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: "id", direction: "asc" });
  const [editData, setEditData] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [query, setQuery] = useState(null)
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
  };

  const handleAdd = () => {
    setForm(!showForm);
  };

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  const sortedData = SpeclistData.sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  const fetchSpeciality = async () => {
    setLoader(true)
    try {
      const config = { _page: currPage, _limit: itemsPerPage };
      const res = await postData1(
        "product/speciality/lists/",
        config,
        true,
        true
      );
      setSpecListData(res?.data?.data);
      setPaging({
        total: res?.data?.total,
        total_pages: res?.data?.total_pages,
      });
    } catch (error) {
      console.error(error)
    } finally {
      setLoader(false);
    }
  }
  useEffect(() => {
    fetchSpeciality();
  }, [currPage, showForm, itemsPerPage]);

  const filteredData = SpeclistData.filter((item) => {
    const q = query ? query.trim().toLowerCase() : "";
    if (!q) return true;

    return (
      (item?.name || "").toLowerCase().includes(q) ||
      String(item?.id || "").toLowerCase().includes(q)
    );
  });
  const deleteSpec = async (id) => {

    try {
      const res = await deleteSpeciality(id);
      console.log("first", res)
      if (res) {

        toast.success("Speciality Deleted Successfully!");
        fetchSpeciality();
      }
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error("Failed to delete speciality. Please try again.");
    }
  };
  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowConfirm(true);
  };

  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>SPECIALITY MANAGEMENT</h1>
        <div className="w-[40%] flex items-center border border-[#019c89] rounded-md px-3 py-1 shadow-sm ">
          <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
          <input
            type="text"
            placeholder="Search by Id, Name..."
            className="w-full outline-none bg-transparent text-[#019c89] placeholder-[#019c89]"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>
      <div className={styles.listHead}>
        <span className={commonCss.addBtn} onClick={handleAdd}>
          ADD
        </span>
      </div>
      <div className={styles.dataItems + " " + commonCss.catItems}>
        <div className={styles.itemHead} style={{ justifyContent: "space-around" }}>
          <span onClick={() => handleSort("id")}>
            ID
            {sortConfig.key === "id" && (
              <i className={`bi bi-chevron-${sortConfig.direction === "asc" ? "up" : "down"}`} />
            )}
          </span>
          <span onClick={() => handleSort("name")}>
            NAME
            {sortConfig.key === "name" && (
              <i className={`bi bi-chevron-${sortConfig.direction === "asc" ? "up" : "down"}`} />
            )}
          </span>
          <span onClick={() => handleSort("actions")}>
            ACTIONS
            {sortConfig.key === "actions" && (
              <i className={`bi bi-chevron-${sortConfig.direction === "asc" ? "up" : "down"}`} />
            )}
          </span>
        </div>

        {
          filteredData.length > 0 ? (
            filteredData.map((data, index) => {
              return (
                <div
                  className={styles.itemData}
                  key={index}
                  style={{ justifyContent: "space-around" }}
                >
                  <span>{data?.id}</span>
                  <span>{data?.name}</span>
                  <span className={styles.actionIcons} style={{ display: "flex", gap: "10px" }}>
                    <FiEdit className="cursor-pointer"
                      onClick={() => { setEditData(data); handleAdd() }}
                    />
                    {/* <RiDeleteBin6Line
                      className="cursor-pointer text-red-500 hover:text-red-700"
                      onClick={() => handleDeleteClick(data.uid)}
                    /> */}

                  </span>
                </div>
              );
            })
          ) : (
            <div className="flex items-center justify-center text-gray-500 py-4">
              <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
              <span>No results found</span>
            </div>
          )


        }
        {showConfirm && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded shadow-lg text-center">
              <p className="mb-4 text-lg font-semibold">Are you sure you want to delete this speciality?</p>
              <div className="flex justify-center gap-4">
                <button
                  onClick={() => {
                    deleteSpec(selectedId);
                    setShowConfirm(false);
                  }}
                  className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                >
                  Yes, Delete
                </button>
                <button
                  onClick={() => setShowConfirm(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        <Pagination
          total={paging?.total}
          perPage={itemsPerPage}
          setPerPage={setItemsPerPage}
          currPage={currPage}
          prevPage={prevPage}
          tPage={paging?.total_pages}
          updatePage={updatePage}
          setCurrPage={setCurrPage} // Add this prop
        />

        {loader && <Loader />}
      </div>

      {showForm && <AddSpeciality handleAdd={handleAdd} editData={editData} setEditData={setEditData} />}
    </section>
  );
};

const AddSpeciality = ({ handleAdd, editData, setEditData }) => {
  const [userSpec, setUserSpec] = useState(editData ? editData.name : "");
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setUserSpec(e.target.value);
    setError(false); // reset error when typing
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (userSpec.trim().length < 2) {
      setError("Enter a valid speciality (min 2 chars)");
      return;
    }

    try {
      if (editData) {
        // update existing speciality
        const data = {
          name: userSpec
        }
        const res = await updateSpecialityList(editData.uid, data);
        if (res) {
          toast.success("Speciality updated successfully!");
          handleAdd();
          setEditData(null);
        } else {
          throw new Error("Update failed");
        }
      } else {
        // add new speciality
        const res = await postData1(
          "product/speciality/add/",
          { name: userSpec },
          true,
          true
        );

        if (res) {
          toast.success("Speciality added successfully!");
          handleAdd();
          setEditData(null);
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Specility Already Exists. Something went wrong.");
    }
  };

  return (
    <React.Fragment>
      <form className={commonCss.popContiner} onSubmit={submitForm}>
        <h2>
          {editData ? "EDIT SPECIALITY" : "ADD SPECIALITY"}
          <i
            onClick={() => {
              handleAdd();
              setEditData(null);
            }}
            className="bi bi-x-lg"
            style={{ cursor: "pointer" }}
          ></i>
        </h2>

        <p>SPECIALITY NAME</p>
        <input
          type="text"
          placeholder="Write speciality"
          value={userSpec}
          onChange={handleChange}
        />
        {error && <span style={{ color: "red" }}>{error}</span>}
        <input type="submit" value={editData ? "Update" : "Add"} />
      </form>

      <BackgroundBlur />
      <ToastContainer />
    </React.Fragment>
  );
};


// const AddSpeciality = ({ handleAdd, editData, setEditData }) => {

//   const [userSpec, setUserSpec] = useState(
//     editData ? editData.name : ""
//   );
//   const [error, setError] = useState(false);

//   // console.log("Edit Data:", editData);
//   const handleChange = (e) => {
//     let value = e.currentTarget.value;
//     setUserSpec(value);
//   };

//   const submitForm = async (e,) => {
//     e.preventDefault();
//     if (userSpec.length < 2) {
//       setError("Enter Correct Speciality");
//       return;
//     }
//     if (editData) {
//       const res = await updateSpecialityList(editData.id, userSpec)
//     } else {
//       const res = await postData1(
//         "product/speciality/add/",
//         {
//           name: userSpec
//         },
//         true,
//         true
//       );

//       if (res.status_code === 200) {
//         handleAdd();
//         setEditData(null)
//       } else {
//         toast.error("Something went wrong, try again!");
//       }
//     }


//   };


//   return (
//     <React.Fragment>
//       <form className={commonCss.popContiner} onSubmit={submitForm}>
//         <h2>
//           ADD SPECIALITY
//           <i
//             onClick={() => { handleAdd(); setEditData(null) }}
//             className="bi bi-x-lg"
//             style={{ cursor: "pointer" }}
//           ></i>
//         </h2>
//         <p>SPECIALITY NAME</p>
//         <input
//           type="text"
//           placeholder="write speciality"
//           value={userSpec}
//           onChange={handleChange}
//         />
//         {error && <span style={{ color: "red" }}>{error}</span>}
//         <input type="submit" value={editData ? "Edit" : "Add"} />
//       </form>
//       <BackgroundBlur />
//       <ToastContainer />
//     </React.Fragment>
//   );
// };
